import classNames from 'classnames';
import React from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';

export const AdministratorLayout: React.FC = () => {
  const location = useLocation();
  const path = location.pathname.split('/').pop();

  const subMenu = [
    { link: '', label: 'User Management' },
    { link: 'custom-field', label: 'Custom Field' },
  ];

  return (
    <div className="flex flex-col gap-3">
      <div className="flex flex-row gap-4 p-3 mx-4 bg-white rounded-md shadow-md">
        {subMenu.map(menu => (
          <Link
            key={menu.link}
            to={menu.link}
            className={classNames(
              'text-sm text-gray-500 hover:text-black hover:underline underline-offset-4',
              {
                ['!text-black underline']:
                  path === menu.link ||
                  (path == 'administrator' && menu.link === ''),
              },
            )}
          >
            {menu.label}
          </Link>
        ))}
      </div>

      <Outlet />
    </div>
  );
};
